/**
 * Configuración de marca/branding de la aplicación.
 */

export const BRANDING = {
  APP_NAME: "shazon",
  APP_TITLE: "shazon — Forja de pensamiento",
  APP_DESCRIPTION: "Plataforma de espacios temáticos con generación documental con IA",
  LOGO_PATH: "/logo-shazon.png",
  LOGO_FULL_PATH: "/shazon-full.png",
  LOGO_ALT: "shazon",
  LOGO_SIDEBAR_WIDTH: 36,
  LOGO_SIDEBAR_HEIGHT: 36,
  LOGO_LOGIN_WIDTH: 280,
  LOGO_LOGIN_HEIGHT: 280,
  PRIMARY_COLOR: "#5f7aeb",
} as const;
